import BaseModel from './BaseModel';

export default class DataExtractionFieldBase extends BaseModel {
  constructor(data = {}) {
    super({ name: 'DataExtractionFieldBaseDto' }, data);
    this.id = data.id;
    this.title = data.title ?? '';
    this.description = data.description;
    this.required = data.required ?? false;
  }
}
